function init() {
  setupAddToCartGlobalFunction();
}

function setupAddToCartGlobalFunction() {
  window.addToCart = async function (variantIds) {
    if (!Array.isArray(variantIds) || variantIds.length === 0) {
      console.error('addToCart requires an array of variant IDs');
      return;
    }

    const items = variantIds.map(id => ({ id, quantity: 1 }));
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      const data = await response.json();
    
      if (typeof window.SLIDECART_UPDATE === 'function') {
        window.SLIDECART_UPDATE();
      } else {
        console.warn('SLIDECART_UPDATE is not available');
      }
    
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
      } else {
        console.warn('SLIDECART_OPEN is not available');
      }
    } catch (error) {
      console.error('Error adding items to cart:', error);
    }
  };
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});